import { render } from "./Widget1.vue?vue&type=template&id=8d04908e"
import script from "./Widget1.vue?vue&type=script&lang=js"
export * from "./Widget1.vue?vue&type=script&lang=js"
script.render = render

export default script